// Quack Snake — grow the duck line, don't bite your tail.
export function createSnake(host) {
  const { ctx, input } = host;
  const N = 20, W = host.W, H = host.H, cell = W / N;
  let snake, dir, ndir, food, t, speed;
  const spawnFood = () => { while (true) { const f = { x: (Math.random() * N) | 0, y: (Math.random() * N) | 0 }; if (!snake.some((s) => s.x === f.x && s.y === f.y)) return f; } };
  snake = [{ x: 10, y: 10 }, { x: 9, y: 10 }, { x: 8, y: 10 }]; dir = { x: 1, y: 0 }; ndir = dir; t = 0; speed = 0.12; food = spawnFood();
  return {
    dim: "2d", w: W, h: H, controls: ["left", "right", "up", "down"], score: 0, over: false,
    frame(dt) {
      for (const a of input.taps) {
        if (a === "left" && dir.x !== 1) ndir = { x: -1, y: 0 };
        if (a === "right" && dir.x !== -1) ndir = { x: 1, y: 0 };
        if (a === "up" && dir.y !== 1) ndir = { x: 0, y: -1 };
        if (a === "down" && dir.y !== -1) ndir = { x: 0, y: 1 };
      }
      t += dt;
      if (t >= speed) {
        t = 0; dir = ndir;
        const head = { x: snake[0].x + dir.x, y: snake[0].y + dir.y };
        if (head.x < 0 || head.y < 0 || head.x >= N || head.y >= N || snake.some((s) => s.x === head.x && s.y === head.y)) { this.over = true; host.sfx.hit?.(); }
        else { snake.unshift(head); if (head.x === food.x && head.y === food.y) { this.score += 10; host.sfx.coin?.(); food = spawnFood(); speed = Math.max(0.05, speed - 0.004); } else snake.pop(); }
      }
      ctx.fillStyle = "#08122a"; ctx.fillRect(0, 0, W, H);
      ctx.strokeStyle = "rgba(255,255,255,0.04)";
      for (let i = 1; i < N; i++) { ctx.beginPath(); ctx.moveTo(i * cell, 0); ctx.lineTo(i * cell, H); ctx.moveTo(0, i * cell); ctx.lineTo(W, i * cell); ctx.stroke(); }
      ctx.fillStyle = "#f59e0b"; ctx.beginPath(); ctx.arc(food.x * cell + cell / 2, food.y * cell + cell / 2, cell / 2 - 3, 0, 7); ctx.fill();
      snake.forEach((s, idx) => { ctx.fillStyle = idx === 0 ? "#22d3ee" : "#0891b2"; ctx.fillRect(s.x * cell + 1, s.y * cell + 1, cell - 2, cell - 2); });
      const h0 = snake[0]; ctx.fillStyle = "#fff"; ctx.fillRect(h0.x * cell + cell * 0.55, h0.y * cell + cell * 0.2, 4, 4);
    },
  };
}
